import React, { useState } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import ToolTip, { TooltipElementType } from "@swiggy-private/dls-web-core/dist/components/Tooltip";
import { ApplyCouponPotentialComms } from "@swiggy-private/cart-types";
import { useFooterCommsVisibility } from "../footer-comms-savings-line-item/hooks/useFooterCommsVisibility";
import { SAVINGS_TOOLTIP_CONSTANTS } from "./constant";

interface TooltipProps {
    footerCommsStrip: ApplyCouponPotentialComms;
    onLoad?: () => void;
}

const SavingsTooltip: React.FC<TooltipProps> = ({ footerCommsStrip, onLoad }) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(true);

    const { allowCommsRender, updateFrequencyCounter } = useFooterCommsVisibility(footerCommsStrip?.type);

    const handleCloseIconClick = () => {
        setIsTooltipVisible(false);
        updateFrequencyCounter();
        onLoad?.();
    };

    if (!isTooltipVisible || isEmpty(footerCommsStrip) || !allowCommsRender || !footerCommsStrip?.text) {
        return null;
    }

    return (
        <ToolTip
            direction="up-left"
            text={footerCommsStrip?.text}
            elementType={TooltipElementType.LEFT_ASSET_60X36}
            onClose={handleCloseIconClick}
            leftAsset={{
                cloudinaryId: footerCommsStrip?.cloudinaryId || "",
                altText: SAVINGS_TOOLTIP_CONSTANTS.ALT_TEXT,
            }}
        />
    );
};

export default SavingsTooltip;
